<template>
  <vx-card no-shadow title="ข้อมูลคริปโต">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Address" v-model="memberData.member_address" name="address" />
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Network</label>
          <vs-select autocomplete class="w-full" v-model="memberData.member_crypto_network" >
             <vs-select-item v-for="(item,index) in dataCrypto" :key="index" :value="item.network" :text="item.network"
             />
          </vs-select>
        </div>
      </div>
    </div>
    <div class="mt-6 flex flex-wrap items-center justify-end">
      <vs-button color="success" class="ml-4 mt-2" @click="addCryptoMember()">ยืนยัน</vs-button>
    </div>
  </vx-card>


</template>

<script>
import axios from '../../../axios'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      popup_otp: false,
      otp: '',
      turnover: 0,
      bank_see: '',
      sum_deposit: 0,
      selectbank:{
        text: '',
        value: ''
      },
      memberData: {},
      dataCrypto: [],
      selectedCrypto: null

    }
  },
  methods: {
    async clearDataInPopup () {
      this.otp = ''
    },
    async addCryptoMember () {
      await axios.post('crypto/member/update', {
        username: this.memberData.member_username,
        network: this.memberData.member_crypto_network,
        address: this.memberData.member_address
      })
        .then(response => (this.error = response.data))

      if (this.error.status === true) {
        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title : 'ทำรายการสำเร็จ'
        })
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title : 'ทำรายการผิดพลาด'
        })
      }
    }
  },

  async mounted () {
    await axios.get('crypto/info').then(response => (this.dataCrypto = response.data))
    await axios
      .get(`/member/${this.$route.params.username}`)
      .then(response => (this.memberData = response.data))
  }
}

</script>
